import { GET_ALL_PELICULAS, SET_PELICULAS_ACTIVO } from "../types";

const initialState = {
  all: [],
  meta: null,
  links: null,
  activo: null,
};

export const peliculasReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PELICULAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case SET_PELICULAS_ACTIVO:
      return {
        ...state,
        activo: action.payload,
      };
    default:
      return state;
  }
};
